export default __webpack_public_path__ + "dedcb29dada0114bcd5d402ff8c770e4.svg";